(ns dashboard.common
  (:require [clojure.string :as str]))

;; TODO: "role" is too high -level thing, we'd want privileges, which are actions that can be allowed
;;       A "role" can then be just a collection  of privileges
(defn roles-are-allowed?
  "Check if roles are allowed to access given route match.

  Parameters:
  - `roles`       User roles
  - `match`       Reitit.core.Match with {:data {:acl #{\"set\" \"of\" \"allowed\" \"roles\"}}} "
  [roles route-match]
  (let [acl (-> route-match :data :acl)]
    (if (some roles acl)
      true
      false)))

(def default-locale
  "Default application locale for locale-sensitive formatting"
  "en-US")

(defn format-date-time
  [date]
  (when date
    (.toLocaleString date
                     ;; This is not the "correct" way to do this, but I think
                     ;; it is the "right" way at least for now. For info see:
                     ;; https://stackoverflow.com/a/2678437/206020
                     (or (.-language js/window.navigator) default-locale))))

(defn format-date
  [date]
  (when date
    (.toLocaleString date
                     ;; This is not the "correct" way to do this, but I think
                     ;; it is the "right" way at least for now. For info see:
                     ;; https://stackoverflow.com/a/2678437/206020
                     (or (.-language js/window.navigator) default-locale)
                     #js {:year "numeric" :month "numeric" :day "numeric"})))

(defn format-date->input
  "Accepts a JS Date and returns a string in the format YYYY-MM-DD.
   Intended to convert a date for use in a JS input=date user control."
  [date]
  (if date
    (let [year (.getFullYear date)
          month (-> (.getMonth date)
                    inc
                    str
                    (.padStart 2 "0"))
          day (-> (.getDate date)
                  str
                  (.padStart 2 "0"))]
      (str year "-" month "-" day))
    ""))

(defn format-input->date
  "Accepts the value of an HTML input=date control and returns a JS date"
  [input-value]
  (if (seq input-value)
    (let [[yy mm dd] (->> (str/split input-value #"[^0-9]+")
                          (map js/parseInt))]
      (js/Date. yy (dec mm) dd))
    nil))

(defn format-score
  ([score] (format-score score default-locale))
  ([score locale]
   (.format (js/Intl.NumberFormat
             locale
             #js {:style "percent"
                  :maximumFractionDigits 2
                  :minimumFractionDigits 2})
            score)))

(def wrapped-text-container-style
  {:display "-webkit-box"
   :-webkit-box-orient "vertical"
   :-webkit-line-clamp 2
   :line-clamp 2
   :overflow "hidden"
   :cursor "s-resize"})

(def expanded-text-container-style
  {:cursor "n-resize"})
